"use client";

import { useEffect, useState } from "react";
import type { PublicLeadFormField } from "@/lib/bitrix24/lead-form-fields";
import {
  leadFormUiFromPublicFields,
} from "@/lib/bitrix24/lead-form-fields";

export type LeadFormConfig = {
  title: string;
  submitLabel: string;
  successMessage: string;
  fields: PublicLeadFormField[];
  ui: ReturnType<typeof leadFormUiFromPublicFields>;
};

const DEFAULT_UI = leadFormUiFromPublicFields([
  { source: "name", label: "Имя", enabled: true, required: true, bitrixTarget: "TITLE" },
  { source: "email", label: "Email", enabled: true, required: true, bitrixTarget: "EMAIL" },
  { source: "phone", label: "Телефон", enabled: true, required: false, bitrixTarget: "PHONE" },
  { source: "company", label: "Компания", enabled: false, required: false, bitrixTarget: "COMMENTS" },
  { source: "message", label: "Сообщение", enabled: false, required: false, bitrixTarget: "COMMENTS" },
]);

export function useLeadFormConfig(
  formCaseKey: string,
  enabled: boolean,
  titleOverride?: string,
): LeadFormConfig | null {
  const [config, setConfig] = useState<LeadFormConfig | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    void fetch(`/api/public/lead-forms/${encodeURIComponent(formCaseKey)}`)
      .then(async (res) => {
        const data = (await res.json().catch(() => null)) as {
          title?: string;
          submitLabel?: string;
          successMessage?: string;
          fields?: PublicLeadFormField[];
        } | null;
        if (cancelled || !data?.fields?.length) return;
        setConfig({
          title: titleOverride || data.title || "Оставить заявку",
          submitLabel: data.submitLabel || "Отправить",
          successMessage: data.successMessage || "Заявка отправлена",
          fields: data.fields,
          ui: leadFormUiFromPublicFields(data.fields),
        });
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [enabled, formCaseKey, titleOverride]);

  return config;
}

export { DEFAULT_UI };
